import React from "react";
import { CircularProgress } from "@material-ui/core";

const Spinner = ({ size, value, color }) => {
  return <CircularProgress size={size} value={value} color={color} />;
};

export default Spinner;
